import React, { useState, useEffect } from "react";
import { Radio, Space, Checkbox } from "antd";
import { useSelector } from "react-redux";
import "./ExperienceFilter.css";
import { useParams } from "react-router-dom";

const ExperienceLevel = (props) => {
  const CheckBoxGroup = Checkbox.Group;
  const { id, name } = useParams();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const filters = useSelector(
    (state) => state.searchSkillListingReducer.filters
  );


  const Count = useSelector(
    (state) => state.searchSkillListingReducer.skillListingCount
  );

  const countLoading = useSelector(
    (state) => state.searchSkillListingReducer.countLoading
  );

  const onExperienceRadioClicked = (e) => {
    // props.setcheck(e.target.value);
    // setCheckedBoxTest(...e)
    props.setCheckedBox(e);
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const ExperienceName = [
    'Less than 1 year',
    '1-2 years',
    '3-5 years',
    '6-10 years',
    'More than 10 years',
  ];
  
  const ExperienceNames = [
    { id: "Less than 1 year", Name: "Less than 1 year" },
    { id: "1-2 years", Name: "1-2 years" },
    { id: "3-5 years", Name: "3-5 years" },
    { id: "6-10 years", Name: "6-10 years" },
    { id: "More than 10 years", Name: "More than 10 years" },
  ];

  const generateCheckBoxOptions = () => {
    const options = ExperienceName.map((name) => {
      const matchingCount = Count?.result?.experienceCount?.find(
        (count) => count?.title === name
      );
      const count = matchingCount ? matchingCount.count : 0;
  
      return {
        label: (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{name}</span>
            {/* { props?.fromCandMkt || id ? null : <> <span>({count})</span> </>} */}
          </div>
        ),
        value: name,
      };
    });
  
    return options;
  };


  return (
    <>
      <CheckBoxGroup
        style={{ display: "flex", flexDirection: "column", width: '100%',height:'10rem', justifyContent:'space-between', marginBottom:'1rem' }}
        options={generateCheckBoxOptions()}
        value={props.checkBox}
        onChange={onExperienceRadioClicked}
      />
    </>
  );
};

export default ExperienceLevel;
